import styled from "styled-components";

import { Block } from "commons";

export const AuthBlock = styled(Block)`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: ${props => (props.fullWidth ? "100%" : "400px")};
    width: ${props => (props.fullWidth ? "100%" : "400px")};
    text-align: center;
    color: #000;

    @media (max-width: ${props => props.theme.maxWidth}) {
        width: 100%;
    }
`;
